import { Tools } from "react-sketch-master";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export const TEXT_FONT_FAMILY = "\"Ampliospeech Noto\"";

export const MAXIMUM_CODES_FOR_LETTER = 6;

export const MODES = {
  TEXT_EDIT: "text",
  SKETCHING: "sketching",
  CODING: "coding",
};

export const SKETCH_TOOLS = {
  PENCIL: { type: "pencil", tool: Tools.Pencil, lineWidth: 5 },
  ERASER: { type: "eraser", tool: Tools.Select, lineWidth: 5 },
  MOVES: { type: "moves", tool: Tools.Select, lineWidth: 5 },
  RECTANGLE: { type: "rectangle", tool: Tools.Rectangle, lineWidth: 3 },
};

export const CODE_TYPES = {
  BEFORE: 1,
  ABOVE_BEFORE: 2,
  ABOVE_AFTER: 3,
  AFTER: 4,
  REPLACE: 5,
  ABOVE_BEFORE_AFTER: 6,
  TO_UPPER_CASE: 7,
};

export const CODE_POSITION = {
  NONE: -1,
  TOP: 1,
  CENTER: 2,
  BOTTOM: 3,
  LEFT: 4,
  RIGHT: 5,
  RIGHT_LEFT: 6,
};
  
export const COLORS = [
  "#EDC74F",
  "#F17148",
  "#C02546",
  
  "#d967bf",
  "#87b2ed",
  "#3E5DE6",
  
  "#8d5bbf",
  "#56cc91",
  "#217049",
];

export const CODES = [
  { id: 1, name: "G-curve", example: "ŋ", position: CODE_POSITION.BOTTOM, renderOrder: 1, title: `n${String.fromCharCode(0x0321)}`, progressGroup: 2, value: String.fromCharCode(0x0321), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 2, name: "Cedilla", example: "ç", position: CODE_POSITION.BOTTOM, renderOrder: 1, title: `c${String.fromCharCode(0x0327)}`, progressGroup: 5, value: String.fromCharCode(0x0327), letters: 1, type: CODE_TYPES.ABOVE_AFTER },

  { id: 100, name: "Breve", example: "x̆", position: CODE_POSITION.TOP, renderOrder: 3, title: `v${String.fromCharCode(0x0306)}`, progressGroup: 1, value: String.fromCharCode(0x0306), letters: 1, type: CODE_TYPES.ABOVE_AFTER },

  { id: 101,
    name: "Double Breve",
    example: "x͝x",
    position: CODE_POSITION.TOP,
    renderOrder: 11,
    title: `v${String.fromCharCode(0x035D)}v`,
    progressGroup: 1,
    value: String.fromCharCode(0x035D),
    hights: [
      { hight: 1, value: String.fromCharCode(0xE031) },
      { hight: 2, value: String.fromCharCode(0xE034) },
      { hight: 3, value: String.fromCharCode(0xE037) },
      { hight: 4, value: String.fromCharCode(0xE03A) },
      { hight: 5, value: String.fromCharCode(0xE03D) },
    ],
    exceptions: [
      {
        chars: ["f", "i", "l"],
        value: String.fromCharCode(0xE002),
        hights: [
          { hight: 1, value: String.fromCharCode(0xE032) },
          { hight: 2, value: String.fromCharCode(0xE035) },
          { hight: 3, value: String.fromCharCode(0xE038) },
          { hight: 4, value: String.fromCharCode(0xE03B) },
          { hight: 5, value: String.fromCharCode(0xE03E) },
        ],
      }, // E002 for narrow combinations
      {
        chars: ["w", "m"],
        value: String.fromCharCode(0xE003),
        hights: [
          { hight: 1, value: String.fromCharCode(0xE033) },
          { hight: 2, value: String.fromCharCode(0xE036) },
          { hight: 3, value: String.fromCharCode(0xE039) },
          { hight: 4, value: String.fromCharCode(0xE03C) },
          { hight: 5, value: String.fromCharCode(0xE03F) },
        ],
      }, // E003 for wide ones
    ],
    letters: 2,
    type: CODE_TYPES.ABOVE_AFTER,
  },
  
  { id: 102, name: "Solid Dot", example: "ẋ", position: CODE_POSITION.TOP, renderOrder: 2, title: `v${String.fromCharCode(0x0307)}`, progressGroup: 1, value: String.fromCharCode(0x0307), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 103, name: "Dieresis", example: "ẍ", position: CODE_POSITION.TOP, renderOrder: 2, title: `v${String.fromCharCode(0x0308)}`, progressGroup: 3, value: String.fromCharCode(0x0308), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 104,
    name: "Arc",
    example: "x͜x",
    position: CODE_POSITION.BOTTOM,
    renderOrder: 9,
    title: `x${String.fromCharCode(0x035C)}x`,
    progressGroup: 3,
    value: String.fromCharCode(0x035C),
    exceptions: [
      { chars: ["f", "i", "l"], value: String.fromCharCode(0xE006) }, // E006 for narrow combinations
      { chars: ["w", "m"], value: String.fromCharCode(0xE007) }, // E007 for wide ones
    ],
    letters: 2,
    type: CODE_TYPES.ABOVE_AFTER,
  },
  { id: 105, name: "Tilde", example: "x̃", position: CODE_POSITION.TOP, renderOrder: 3, title: `v${String.fromCharCode(0x0303)}`, progressGroup: 3, value: String.fromCharCode(0x0303), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 106, name: "Circumflex", example: "x̂", position: CODE_POSITION.TOP, renderOrder: 3, title: `v${String.fromCharCode(0x0302)}`, progressGroup: 3, value: String.fromCharCode(0x0302), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 107, name: "Macron", example: "x̄", position: CODE_POSITION.TOP, renderOrder: 4, title: `v${String.fromCharCode(0x0304)}`, progressGroup: 1, value: String.fromCharCode(0x0304), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 108,
    name: "Double Macron",
    example: "x͞x",
    position: CODE_POSITION.TOP,
    renderOrder: 11,
    title: `v${String.fromCharCode(0xFE26)}v`,
    progressGroup: 1,
    value: String.fromCharCode(0xFE26),
    hights: [
      { hight: 1, value: String.fromCharCode(0xE041) },
      { hight: 2, value: String.fromCharCode(0xE044) },
      { hight: 3, value: String.fromCharCode(0xE047) },
      { hight: 4, value: String.fromCharCode(0xE04A) },
      { hight: 5, value: String.fromCharCode(0xE04D) },
    ],
    exceptions: [
      { chars: ["e", "f", "i", "l"],
        value: String.fromCharCode(0xE004),
        hights: [
          { hight: 1, value: String.fromCharCode(0xE042) },
          { hight: 2, value: String.fromCharCode(0xE045) },
          { hight: 3, value: String.fromCharCode(0xE048) },
          { hight: 4, value: String.fromCharCode(0xE04B) },
          { hight: 5, value: String.fromCharCode(0xE04E) },
        ],
      }, // E004 for narrow combinations
      { chars: ["w", "m"],
        value: String.fromCharCode(0xE005),
        hights: [
          { hight: 1, value: String.fromCharCode(0xE044) },
          { hight: 2, value: String.fromCharCode(0xE046) },
          { hight: 3, value: String.fromCharCode(0xE049) },
          { hight: 4, value: String.fromCharCode(0xE04C) },
          { hight: 5, value: String.fromCharCode(0xE04F) },
        ],
      }, // E005 for wide ones
    ],
    letters: 1,
    type: CODE_TYPES.ABOVE_AFTER,
  },
  { id: 109, name: "Modified Macron", example: "v᷵", position: CODE_POSITION.TOP, renderOrder: 2, title: `v${String.fromCharCode(0x1DF5)}`, progressGroup: 5, value: String.fromCharCode(0x1DF5), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 200,
    name: "K-line",
    example: "|x",
    position: CODE_POSITION.LEFT,
    renderOrder: 1,
    title: `${String.fromCharCode(0x23B8)}c`,
    progressGroup: 2,
    value: String.fromCharCode(0x23B8),
    exceptions: [
      { chars: ["b", "d", "f", "h"], value: String.fromCharCode(0xE00B) }, // E00B for letters with ascenders
      { chars: ["g", "j", "p", "q", "y"], value: String.fromCharCode(0xE00D) }, // E00D for descenders
    ],
    letters: 1,
    type: CODE_TYPES.ABOVE_BEFORE,
  },
  { id: 201, name: "Bracket", example: "[x", position: CODE_POSITION.LEFT, renderOrder: 5, title: `${String.fromCharCode(0x005B)}x`, progressGroup: 3, value: String.fromCharCode(0x005B), letters: 1, type: CODE_TYPES.BEFORE },
  { id: 300, name: "Accent Mark", example: "x΄", position: CODE_POSITION.RIGHT, renderOrder: 20, title: `x${String.fromCharCode(0x0384)}`, progressGroup: 1, value: String.fromCharCode(0x0384), letters: 1, type: CODE_TYPES.AFTER },
  { id: 301, name: "Open Dot", example: "x°", position: CODE_POSITION.RIGHT, renderOrder: 20, title: `x${String.fromCharCode(0x00B0)}`, progressGroup: 1, value: String.fromCharCode(0x00B0), letters: 1, type: CODE_TYPES.AFTER },

  { id: 400, name: "Z-line", example: "", position: CODE_POSITION.CENTER, renderOrder: 5, title: `c${String.fromCharCode(0x0336)}`, progressGroup: 1, value: String.fromCharCode(0x0336), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 401,
    name: "Under Line",
    example: "",
    position: CODE_POSITION.BOTTOM,
    renderOrder: 5,
    title: `x${String.fromCharCode(0x0332)}`,
    progressGroup: 2,
    value: String.fromCharCode(0x0332),
    /*
    exceptions: [
      { chars: ["f", "i", "j", "l", "t", "I", "J"], value: String.fromCharCode(0xE020) }, // E020 for narrow shapes (f i j l t I J)
      { chars: ["m", "w", "N", "M", "K", "O", "W", "Q", "C", "D", "U", "A", "G"], value: String.fromCharCode(0xE021) }, // E021 for wide shapes (m w N M K O W Q C D U A G).
    ],
    */
    letters: 1,
    type: CODE_TYPES.ABOVE_AFTER,
  },
  { id: 402, name: "Slash", example: "\\", position: CODE_POSITION.CENTER, renderOrder: 5, title: `x${String.fromCharCode(0x20E5)}`, progressGroup: 1, value: String.fromCharCode(0x20E5), letters: 1, type: CODE_TYPES.ABOVE_AFTER },

  { id: 403, name: "Vowel", example: "xͮ", position: CODE_POSITION.TOP, renderOrder: 10, title: `x${String.fromCharCode(0x036E)}`, progressGroup: 1, value: String.fromCharCode(0x036E), letters: 1, type: CODE_TYPES.ABOVE_AFTER, replaceGroup: 1 },
  { id: 404, name: "Consonant", example: "xͨ", position: CODE_POSITION.TOP, renderOrder: 10, title: `x${String.fromCharCode(0x0368)}`, progressGroup: 1, value: String.fromCharCode(0x0368), letters: 1, type: CODE_TYPES.ABOVE_AFTER, replaceGroup: 1 },
  { id: 405, name: "T-Line", example: "eđ", targets: ["d"], position: CODE_POSITION.CENTER, renderOrder: 1, title: `e${String.fromCharCode(0x0111)}`, progressGroup: 1, value: String.fromCharCode(0x0111), letters: 1, type: CODE_TYPES.REPLACE },
  { id: 406, name: "Syllable Division", example: "x|x", position: CODE_POSITION.RIGHT, renderOrder: 11, title: "x|x", progressGroup: 1, value: "|", exceptions: [], letters: 1, type: CODE_TYPES.ABOVE_AFTER },
];
  
export const CODES_ESPERANZA = [
  { id: 1000, name: "Accent mark", example: "x́", position: CODE_POSITION.TOP, renderOrder: 1, title: `x${String.fromCharCode(0x0301)}`, progressGroup: 1, value: String.fromCharCode(0x0301), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 1401,
    name: "Under Line",
    example: "x̲",
    position: CODE_POSITION.BOTTOM,
    renderOrder: 5,
    title: `x${String.fromCharCode(0x0332)}`,
    progressGroup: 1,
    value: String.fromCharCode(0x0332),
    /*
    exceptions: [
      { chars: ["f", "i", "j", "l", "t", "I", "J"], value: String.fromCharCode(0xE020) }, // E020 for narrow shapes (f i j l t I J)
      { chars: ["m", "w", "N", "M", "K", "O", "W", "Q", "C", "D", "U", "A", "G"], value: String.fromCharCode(0xE021) }, // E021 for wide shapes (m w N M K O W Q C D U A G)
    ],
    */
    letters: 1,
    type: CODE_TYPES.ABOVE_AFTER,
  },

  { id: 1402, name: "Syllable Division", example: "x|x", position: CODE_POSITION.RIGHT, renderOrder: 10, title: "x|x", progressGroup: 1, value: "|", exceptions: [], letters: 1, type: CODE_TYPES.ABOVE_AFTER },

  { id: 1403, name: "Exclamation Mark", example: "¡", position: CODE_POSITION.LEFT, renderOrder: 20, title: `x${String.fromCharCode(0x00A1)}`, progressGroup: 1, value: String.fromCharCode(0x00A1), letters: 1, type: CODE_TYPES.ABOVE_BEFORE },
  { id: 1404, name: "Exclamation Mark", example: "!", position: CODE_POSITION.RIGHT, renderOrder: 20, title: "x!", progressGroup: 1, value: "!", letters: 1, type: CODE_TYPES.ABOVE_AFTER },

  { id: 1405, name: "Consonant", example: "xͨ", position: CODE_POSITION.TOP, renderOrder: 10, title: `x${String.fromCharCode(0x0368)}`, progressGroup: 1, value: String.fromCharCode(0x0368), letters: 1, type: CODE_TYPES.ABOVE_AFTER, replaceGroup: 1 },
  { id: 1406, name: "Vowel", example: "xͮ", position: CODE_POSITION.TOP, renderOrder: 10, title: `x${String.fromCharCode(0x036E)}`, progressGroup: 1, value: String.fromCharCode(0x036E), letters: 1, type: CODE_TYPES.ABOVE_AFTER, replaceGroup: 1 },

  { id: 1407, name: "Comma", example: ",", position: CODE_POSITION.RIGHT, renderOrder: 20, title: "x,", progressGroup: 1, value: ",", letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 1408, name: "Colon", example: ":", position: CODE_POSITION.RIGHT, renderOrder: 20, title: "x:", progressGroup: 1, value: ":", letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 1409, name: "Semicolon", example: ";", position: CODE_POSITION.RIGHT, renderOrder: 20, title: "x;", progressGroup: 1, value: ";", letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 1410, name: "Period", example: ".", position: CODE_POSITION.RIGHT, renderOrder: 20, title: "x.", progressGroup: 1, value: ".", letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  //{ id: 1411, name: "Quotation Marks", example: "\"", position: CODE_POSITION.RIGHT_LEFT, renderOrder: 10, title: "\"x\"", progressGroup: 1, value: "\"", letters: 1, type: CODE_TYPES.ABOVE_BEFORE_AFTER },
  { id: 1412, name: "Question Mark", example: "¿", position: CODE_POSITION.LEFT, renderOrder: 20, title: `x${String.fromCharCode(0x00BF)}`, progressGroup: 1, value: String.fromCharCode(0x00BF), letters: 1, type: CODE_TYPES.ABOVE_BEFORE },
  { id: 1413, name: "Question Mark", example: "?", position: CODE_POSITION.RIGHT, renderOrder: 20, title: `x${String.fromCharCode(0x003F)}`, progressGroup: 1, value: String.fromCharCode(0x003F), letters: 1, type: CODE_TYPES.ABOVE_AFTER },
  { id: 1414, name: "Hyphen", example: "–", position: CODE_POSITION.LEFT, renderOrder: 20, title: `${String.fromCharCode(0x2013)}x`, progressGroup: 1, value: String.fromCharCode(0x2013), letters: 1, type: CODE_TYPES.ABOVE_BEFORE },
  { id: 1415, name: "Capital Letter", example: "x->X", position: CODE_POSITION.NONE, renderOrder: 1, title: ["x", <FontAwesomeIcon style={{ width: 10 }} icon={faArrowRight} />, "X"], progressGroup: 1, value: String.fromCharCode(0x2013), letters: 1, type: CODE_TYPES.TO_UPPER_CASE },

  { id: 1416, name: "Quotation Mark", example: "\"", position: CODE_POSITION.RIGHT, renderOrder: 22, title: "\"x", progressGroup: 1, value: "\"", letters: 1, type: CODE_TYPES.ABOVE_BEFORE },
  { id: 1417, name: "Quotation Mark", example: "\"", position: CODE_POSITION.LEFT, renderOrder: 22, title: "x\"", progressGroup: 1, value: "\"", letters: 1, type: CODE_TYPES.ABOVE_AFTER },
];

export const MTA_BUTTONS = [
  [100, 107, 300, 402, 301, 102, 400, 401, 1, 200, 406],
  [403, 404, 101, 108, 104, 201, 405, 106, 105, 103, 109, 2],
];

export const ESPERANZA_BUTTONS = [
  [1402, 1405, 1406, 1401, 1410, 1412, 1413, 1415],
  [1403, 1404, 1000, 1407, 1408, 1409, 1416, 1417, 1414],
];

export const getEmptyStateLetter = () => ({ codes: [], color: undefined });

